const headers = {
  เลขร้องทุกข์: "complaintCode",
  วันที่ยื่นเรื่อง: "complaintDateStr",
  ช่องทาง: "channelName",
  //'ผู้ประกอบการ / ชื่อผู้ร้องทุกข์ หรือ ':'cusname',
  ผู้ประกอบการ: {
    callback: (value) => {
      //Handle null before split(",")//
      let records = value.cusname != null ?value.cusname.split(","):[];

      let results = [];

      records.forEach((value) => {
        try {
          //console.log("propValue", value);

          let propSplit = value.split(":");

          let propObj = {};

          if (propSplit[0] !== null && propSplit[0] !== undefined) {
            propObj.type = propSplit[0];
          }

          if (propSplit[1] !== null && propSplit[1] !== undefined) {
            propObj.text = propSplit[1];
          } else {
            propObj.text = "";
          }

          results.push(propObj);
        } catch (ex) {
          //console.log("prop split ex", ex);
        }
      });

      let companies = results.filter(function(value) {
        return value.type === "476";
      });

      //console.log('companies', companies, companies.length > 0)

      if (companies.length > 0) {
        return companies.map(c => c.text).join(', ')
      }
      return value.companyName;
    },
  },
  'ชื่อผู้ร้องทุกข์': {
    callback: (value) => {
      //Handle null before split(",")//
      let records = value.cusname != null ?value.cusname.split(","):[];

      let results = [];

      records.forEach((value) => {
        try {
          //console.log("propValue", value);

          let propSplit = value.split(":");

          let propObj = {};

          if (propSplit[0] !== null && propSplit[0] !== undefined) {
            propObj.type = propSplit[0];
          }

          if (propSplit[1] !== null && propSplit[1] !== undefined) {
            propObj.text = propSplit[1];
          } else {
            propObj.text = "";
          }

          results.push(propObj);
        } catch (ex) {
          //console.log("prop split ex", ex);
        }
      });

      let users = results.filter(function(value) {
        return value.type === "3";
      });

      //console.log('user', users, users.length > 0)

      if (users.length > 0) {
        return users.map(u => u.text).join(', ')
      }
      return "";
    },
  },
  'ผู้มอบอำนาจ': {
    callback: (value) => {
      //Handle null before split(",")//
      let records = value.cusname != null ?value.cusname.split(","):[];

      let results = [];

      records.forEach((value) => {
        try {
          //console.log("propValue", value);

          let propSplit = value.split(":");

          let propObj = {};

          if (propSplit[0] !== null && propSplit[0] !== undefined) {
            propObj.type = propSplit[0];
          }

          if (propSplit[1] !== null && propSplit[1] !== undefined) {
            propObj.text = propSplit[1];
          } else {
            propObj.text = "";
          }

          results.push(propObj);
        } catch (ex) {
          console.log("prop split ex", ex);
        }
      });

      let users = results.filter(function(value) {
        return value.type === "8";
      });

      console.log('users', users, users.length > 0)

      if (users.length > 0) {
        return users.map(u => u.text).join(', ')
      }
      return "";
    },
  },
  วันที่ดำเนินการล่าสุด: {
    callback: (value) => {
      return `${value.updateTrackingStr} (${value.awaitDay})`
    },
  },
  ลำดับล่าสุด: "leveldescription",
  สถานะล่าสุด: "statusdescription",
  หน่วยงานรับผิดชอบ: "departmentName",
  ผู้รับผิดชอบ: "name",
  "แบบฟอร์มรอดำเนินการ / แบบฟอร์มอนุมัติ": {
    callback: (value) => {
      if (value.documentTrackingDetails.length > 0) {
        return value.documentTrackingDetails.map(d => `${d.description}(${d.awaitDay})`).join('/ ')
      }
      return "";
    },
  },
};

export default headers;
